import { observer } from 'mobx-react-lite'
import { type JobProgressionHistoryViewModel } from './JobProgressionHistoryViewModel'
import { JobProgressionHistoryModal } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionHistoryModal'

export interface JobProgressionHistoryModalContainerProps {
  vm: JobProgressionHistoryViewModel
}

export const JobProgressionHistoryModalContainer = observer(
  function JobProgressionHistoryModalContainer({
    vm,
  }: JobProgressionHistoryModalContainerProps) {
    return (
      <JobProgressionHistoryModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        items={vm.items.map((item) => ({
          id: item.id,
          title: item.title,
          formattedDateCreated: item.formattedDateCreated,
          createdBy: item.createdBy && {
            avatar: item.createdBy.member.avatar,
            avatarFallback: item.createdBy.member.avatarFallback,
            displayName: item.createdBy.member.displayName,
            roleLabel: item.createdBy.roleLabel,
          },
        }))}
      />
    )
  },
)
